// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.Pkoi6{width:100%}.hTSgX{align-items:center;display:flex;justify-content:space-between;width:100%}.NL1qw{align-items:center;display:flex;gap:16px}.pn8Hp{min-width:190px !important}.rwla2{min-width:640px}.vIs6Z{overflow-x:auto;position:relative}.o6wOA{bottom:0;height:100px;left:0;margin:auto;position:absolute;right:0;top:0;width:100px;z-index:50}._D9Ia{opacity:.5}.Pb4_k{cursor:default}.y1fyk{white-space:nowrap}.z_UGN{min-width:190px}.uaGB9{margin-right:8px}.dw8Nv{margin-left:8px !important}.XldJ1{color:rgba(0,0,0,.54);font-size:12px;font-size:.75rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "Pkoi6",
	"toolbar": "hTSgX",
	"toolbarActions": "NL1qw",
	"statusFilter": "pn8Hp",
	"table": "rwla2",
	"tableWrapper": "vIs6Z",
	"loadingWrapper": "o6wOA",
	"loading": "_D9Ia",
	"row": "Pb4_k",
	"dateCell": "y1fyk",
	"actionCell": "z_UGN",
	"buttonProgress": "uaGB9",
	"rejectButton": "dw8Nv",
	"pagination": "XldJ1"
};
module.exports = ___CSS_LOADER_EXPORT___;
